<template>
  <div id="measureChartFrame">
    <div id="wrapper">
      <!-- Titulos -->
      <b-row style="zoom: 0.9">
        <b-col cols="8">
          <p style="padding-left: 10px">
            Seleccionar un intervalo perzonalizado
          </p>
        </b-col>
        <b-col>
          <p style="padding-left: 10px">
            Seleccione un intervalo preestablecido
          </p>
        </b-col>
      </b-row>
      <!-- Opciones -->
      <b-row style="zoom: 0.9; padding-left: 15px">
        <b-col cols="8" class="selectGroup">
          <b-row>
            <b-col align="middle">
              <p class="intervalo" style="margin-left: 10px">
                Inicio de intervalo
              </p>
              <VueCtkDateTimePicker
                v-model="datePickerValueInit"
                format="YYYY-MM-DD HH:mm"
                label="Inicio de intervalo"
                disabled="true"
              />
            </b-col>
            <b-col align="middle">
              <p class="intervalo" style="margin-left: 10px">
                Fin del intervalo
              </p>
              <VueCtkDateTimePicker
                v-model="datePickerValueEnd"
                format="YYYY-MM-DD HH:mm"
                label="Fin de intervalo - Seleccione fecha y hora"
                button-now-translation="Ahora"
                @is-hidden="selectDateTime()"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col class="text-center">
          <div class="selectGroup">
            <b-button
              variant="primary"
              pill
              @click="updateData('one_hour')"
              :pressed="serverParams.graphFilters.windowSize === 'one_hour'"
              title="Intervalo de 1 hora"
              class="boton"
            >
              <span class="text-uppercase">Hora</span>
            </b-button>

            <b-button
              variant="primary"
              pill
              @click="updateData('one_day')"
              :pressed="serverParams.graphFilters.windowSize === 'one_day'"
              title="Intervalo de 1 día"
              class="boton"
            >
              <span class="text-uppercase">Día</span>
            </b-button>

            <b-button
              variant="primary"
              pill
              @click="updateData('one_week')"
              :pressed="serverParams.graphFilters.windowSize === 'one_week'"
              title="Intervalo de 1 semana"
              class="boton"
            >
              <span class="text-uppercase">Semana</span>
            </b-button>

            <b-button
              variant="primary"
              pill
              @click="updateData('one_month')"
              :pressed="serverParams.graphFilters.windowSize === 'one_month'"
              title="Intervalo de 1 mes"
              class="boton"
            >
              <span class="text-uppercase">Mes</span>
            </b-button>
          </div>
        </b-col>
      </b-row>

      <div>
        <div class="chartWrapper">
          <div v-if="loaded == false">
            <p style="padding-top: 100px">
              <center>
                <div class="fa-3x">
                  <i class="fas fa-spinner fa-spin"></i>
                </div>
                Cargando datos
              </center>
            </p>
          </div>
          <apexchart
            ref="chartmeasures1"
            v-if="loaded"
            height="350"
            width="95%"
            type="line"
            :options="chartOptions"
            :series="series1"
          ></apexchart>
          <apexchart
          class="mt-3"
            ref="chartmeasures2"
            v-if="loaded && adcTemp"
            height="350"
            width="95%"
            type="line"
            :options="chartOptions"
            :series="series2"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Constants from "@/Constants";

export default {
  name: "sensor-measures-chart",
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
  },

  data() {
    return {
      loaded: false,
      adcTemp: false,
      datePickerValueEnd: "",
      selectedSensorID: null,
      selectedTipoID: null,
      serverParams: {
        graphFilters: {
          windowSize: "one_hour",
          windowEnd: Date.now(),
        },
        limit: 0,
      },
      series1: [],
      series2: [],
      chartOptions: {
        chart: {
          type: "line",
          zoom: {
            enabled: true,
          },
        },
        title: {
          text: "",
          align: "center",
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "13px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        stroke: {
          curve: "straight",
          width: 2,
        },
        tooltip: {
          enabled: true,
          shared: true,
          followCursor: true,
          x: {
            show: true,
            format: "dd/MM/yy HH:mm:ss.ff",
          },
        },
        zoom: {
          enabled: true,
          type: "xy",
          autoScaleYaxis: false,
          zoomedArea: {
            fill: {
              color: "#90CAF9",
              opacity: 0.4,
            },
            stroke: {
              color: "#0D47A1",
              opacity: 0.4,
              width: 1,
            },
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
      },
    };
  },
  computed: {
    // un getter computado
    datePickerValueInit: function () {
      var rValue = null;

      if (this.serverParams.graphFilters.windowSize === "one_hour") {
        rValue = this.$moment(this.datePickerValueEnd).add(-1, "hours");
        //this.options.scales.xAxes[0].time.unit = "minute";
      } else if (this.serverParams.graphFilters.windowSize === "one_day") {
        rValue = this.$moment(this.datePickerValueEnd).add(-1, "days");
        //this.options.scales.xAxes[0].time.unit = "hour";
      } else if (this.serverParams.graphFilters.windowSize === "one_week") {
        rValue = this.$moment(this.datePickerValueEnd).add(-1, "week");
        //this.options.scales.xAxes[0].time.unit = "day";
      } else if (this.serverParams.graphFilters.windowSize === "one_month") {
        rValue = this.$moment(this.datePickerValueEnd).add(-1, "months");
        //this.options.scales.xAxes[0].time.unit = "week";
      }
      return rValue;
    },
  },
  methods: {
    // Evento para seleccionar la fecha
    ///////////////////////////////////
    selectDateTime: function () {
      this.updateWindowEnd();
    },

    async updateWindowEnd() {
      if (this.datePickerValueEnd) {
        this.serverParams.graphFilters.windowEnd = this.datePickerValueEnd;
      } else {
        this.serverParams.graphFilters.windowEnd = new Date(
          Date.now()
        ).toString();
      }

      await this.retrieveDataFromSensor(
        this.selectedSensorID,
        this.selectedTipoID
      );
    },

    async updateData(timeline) {
      this.serverParams.graphFilters.windowSize = timeline;
      await this.retrieveDataFromSensor(
        this.selectedSensorID,
        this.selectedTipoID
      );
    },
    ////////////////////////////////////
    ////////////////////////////////////

    // PUNTO DE ENTRADA EXTERNO
    //  PARA POPULAR LAS GRAFICAS A PARTIR DEL ULTIMO DATO
    /////////////////////////////
    async createChart(id, sensorType) {
      // Obtenemos el ultimo dato de la gráfica para autoconfigurar
      // las gráficas desde el ultimo punto
      this.serverParams.limit = 1;
      await DataService.getAllData(id, sensorType, this.serverParams)
        .then(async (response) => {
          this.datePickerValueEnd = this.$moment(response.data);
          this.serverParams.graphFilters.windowEnd = this.datePickerValueEnd;
          await this.retrieveDataFromSensor(id, sensorType);
        })
        .catch((e) => {
          console.log("Error recuperando ultimo dato de la gráfica");
          console.log(e);
        });
    },

    // SOLICITAR DATOS PARA LAS GRAFICAS APEXCHARTS
    //////////////////////////////////////////////
    async retrieveDataFromSensor(idsensor, sensorType) {
      try {
        // Hide chart before request data !important
        this.loaded = false;
        this.selectedSensorID = idsensor;
        this.selectedTipoID = sensorType;

        //Mostramos las dos gráficas
        if(Constants.ID_SENSOR_TYPES.ADCTEMP == sensorType){
          this.adcTemp = true;
        }

        // Get all data from chart
        this.serverParams.limit = 0;
        this.serverParams.graphFilters.windowEnd = new Date(
          this.datePickerValueEnd
        ).toISOString();

        await DataService.getAllData(idsensor, sensorType, this.serverParams)
          .then(async (response) => {

            if(this.adcTemp){
              //console.log(JSON.stringify(response.data.series));
              let localSeries1 = [
                response.data.series[0],
                response.data.series[1],
                response.data.series[2],
                response.data.series[3],
                response.data.series[4],
              ];
              let localSeries2 = [
                response.data.series[5],
                response.data.series[6],
                response.data.series[7],
                response.data.series[8],
              ];
              this.series1 = localSeries1;
              this.series2 = localSeries2;
            } else {
              this.series1 = response.data.series;
            }

            this.loaded = true;
          })
          .catch((err) => {
            this.loaded = true;
            console.log(
              "Error getting filtered data (SensorMeasuresChart.vue :: retrieveDataFromSensor)" +
                err
            );
          });
        // Catch event errors
      } catch (error) {
        console.log("SensorMeasuresChart.vue::  " + error);
      }
    },
  },
  created() {
    this.datePickerValueEnd = this.$moment();
  },
};
</script>

<style scoped>
#measureChartFrame {
  width: 100%;
}

div.toolbar button span {
  font-size: 12px;
  font-weight: bold;
  margin-left: 5px;
}

div.toolbar button {
  margin-right: 5px;
}

.date-time-picker {
  width: 300px !important;
  margin: 0 !important;
}

.labelSeparator {
  margin-top: 10px;
}

.containerDateTime {
  padding-top: 10px;
  text-align: left;
}

.chartWrapper {
  margin-top: 20px;
  border: 1px solid rgba(0, 0, 0, 0.0625);
  padding: 10px;
}

.selectGroup {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 10px;
  height: 88px;
}

.boton {
  margin: 15px 2px 2px 2px;
  font-size: 0.85rem;
}

.intervalo {
  margin: 0px !important;
  text-align: left;
  padding-left: 35px;
  font-size: 0.9rem;
}
</style>
